import { render, staticRenderFns } from "./QuizItem.vue?vue&type=template&id=56fe7f53&scoped=true&"
import script from "./QuizItem.vue?vue&type=script&lang=js&"
export * from "./QuizItem.vue?vue&type=script&lang=js&"
import style0 from "./QuizItem.vue?vue&type=style&index=0&id=56fe7f53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fe7f53",
  null
  
)

/* custom blocks */
import block0 from "./QuizItem.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports